import {http} from 'lib/httpAxios'

export default {
  retrieveToken (data) {
    return http.post('/authentication', data)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/auth.js